import { ButtonProps } from "../../../../types"
import Button from "../button"

interface LinkBtnProps extends ButtonProps {
  theme?: "primary" | "danger" | "alt"
  borderClassName?: string
}

const LinkBtn = ({
  theme = "primary",

  children,
  className = "",
  text = "sm",
  paddingOff = false,
  borderClassName = "border-transparent bg-transparent hover:underline",
  ...rest
}: LinkBtnProps) => {
  const themeKey =
    theme === "primary" ? "primary" : theme === "danger" ? "red" : "primary-alt"

  const themeClassName = `text-${themeKey}-400 hover:text-${themeKey}-500 focus:ring-${themeKey}-300 focus:ring-2 focus:ring-offset-0`

  return (
    <Button
      {...rest}
      className={`${themeClassName} ${className} ${borderClassName}`}
      text={text}
      paddingOff={paddingOff}
    >
      {children}
    </Button>
  )
}
export default LinkBtn
